import React from 'react'
import { FusePageSimple } from '@fuse'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const toolbarHeight = 88

const useStyles = makeStyles((theme) => ({
  toolbar: {
    height: toolbarHeight,
    minHeight: toolbarHeight,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.background,
  },
  fullContainer: {
    '&>.container': {
      width: '100%',
    },
  },
}))

const ContentToolbarPage = ({
  header,
  contentToolbar,
  content,
  contentClassName,
  isFitViewPort,
  isFullContainer,
}) => {
  const classes = useStyles()
  return (
    <FusePageSimple
      classes={{
        content: clsx(
          contentClassName ||
            'px-8 py-24 md:ltr:pl-24 rtl:pr-24 md:ltr:pr-24 rtl:pl-24',
          isFitViewPort && 'flex flex-col flex-auto',
          isFullContainer && classes.fullContainer,
        ),
        toolbar: clsx(classes.toolbar),
      }}
      header={header}
      contentToolbar={contentToolbar}
      content={content}
      isFitViewPort={isFitViewPort}
    />
  )
}

export default ContentToolbarPage
